// account.service.ts
import { AuthenticationResult } from "types/auth.types";
import requester from "./requesters";
import { Profile } from "models";
export const accountService = {
  signIn: (query: { email: string; password: string }) =>
    requester.post<AuthenticationResult>("/auth/login", {
      email: query.email,
      password: query.password,
      platform: "admin",
    }),
  signOut: (data: { accessToken: string | undefined }) =>
    requester.post("/auth/logout", data),
  refreshToken: (refreshToken: string | undefined) =>
    requester.post<{ AuthenticationResult: AuthenticationResult }>(
      "/auth/refresh",
      {
        refreshToken,
      }
    ),
  forgetPassword: (query: { email: string }) =>
    requester.post("/auth/forgot-password", query),
  verifyToken: (query: { token: string }) =>
    requester.post("/auth/verify-reset-password-token", query),
  resetPassword: (query: { email: string; password: string; token: string }) =>
    requester.post("/auth/reset-password", query),
  getProfile: () =>
    requester.get<{
      data: Profile;
      statusCode: number;
      success: boolean;
    }>("/auth/user-profile"),
};
export default accountService;
